import { useEffect, useState, Fragment } from "react";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
  Card,
  CardBody,
  CardFooter,
  Button,
} from "reactstrap/lib";
import styled from "styled-components";
import "react-nice-dates/build/style.css";
import { FormattedMessage } from "react-intl";
import ScrollContainer from "react-indiana-drag-scroll";
import CreateAPLPeriodDocuments from "../Modal/CreateAPLPeriodDocuments";
import {
  DeleteDocument,
  GetAplInformationPersons,
  PostAplInformationPerson,
  UpdateInformationPersonAddUsers,
  UpdateInformationPersonRemoveUsers,
  PostInformationPersonsAndUsersForPeriod,
} from "../../actions/teacherMutations";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { Tab, Tabs, Box } from "@mui/material";
import ModifyAPLInformationPersonModal from "../Modal/ModifyAPLInformationPersonModal";
import ModifySupervisorsModal from "../Modal/ModifySupervisorsModal";
import { BASE_LOGIN_REDIRECT_URL_NO_LWC } from "../../constants/api.constants";
import ButtonSendActivationMail from "../Button/ButtonSendActivationMail";
import axios from "../../services/api/api";
import { v4 as uuid } from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function APLDocumentsAndSupervisors({
  allSupervisors,
  setLevelSupervisor,
  levelSupervisor,
  setSupervisor,
  toggleSupervisorInfo,
  period,
  setPeriod,
  toggleInfoPersonOpen,
  setAplInfoPerson,
  level,
  objId,
  students,
  schoolId,
  programTeachers,
  programId,
  teacherInfo,
}) {
  const deleteDocument = useMutation(DeleteDocument);
  const { mutate } = useMutation(GetAplInformationPersons);
  const postAplInfoPerson = useMutation(PostAplInformationPerson);
  const updateInfoPersonAddUsers = useMutation(UpdateInformationPersonAddUsers);
  const postAplInfoPersonsAndUsers = useMutation(
    PostInformationPersonsAndUsersForPeriod
  );
  const updateInfoPersonRemoveUsers = useMutation(
    UpdateInformationPersonRemoveUsers
  );

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setAplDocumentsWithUsers([]);
    setIsOpen(!isOpen);
  };
  const [informationPersonIsOpen, setInformationPersonIsOpen] = useState(false);
  const [modifySupervisorsOpen, setModifySupervisorsOpen] = useState(false);
  const toggleInformationPerson = () =>
    setInformationPersonIsOpen(!informationPersonIsOpen);
  const toggleSupervisorModifyer = () => {
    setModifySupervisorsOpen(!modifySupervisorsOpen);
  };
  const [aplDocumentsWithUsers, setAplDocumentsWithUsers] = useState([]);
  const [informationPersons, setInformationPersons] = useState([]);
  const [infoPersonUsers, setInfoPersonUsers] = useState([]);
  const [listOfStudentIds, setListOfStudentIds] = useState([]);
  const [allStudents, setAllStudents] = useState([]);
  const [supervisorsInPeriod, setSupervisorsInPeriod] = useState([]);

  useEffect(() => {
    if (period?.period) {
      const tempSupervisorsInPeriod = [];
      period.period.students.forEach((stud) => {
        stud.supervisors.forEach((sv) => {
          tempSupervisorsInPeriod.push({ ...sv.supervisor });
        });
      });
      setSupervisorsInPeriod(tempSupervisorsInPeriod);
    }
  }, [period]);

  useEffect(() => {
    const tempAllStudents = [];
    students.forEach((stud) => {
      const studentToAdd = {
        company: null,
        companyId: null,
        id: stud.id,
        period: null,
        periodId: null,
        student: stud,
        studentId: stud.id,
        supervisor: null,
        supervisorId: null,
      };
      tempAllStudents.push(studentToAdd);
    });
    setAllStudents(tempAllStudents);
  }, [students]);

  useEffect(() => {
    let studentIds = [];
    students.forEach((stud) => {
      studentIds.push(stud.id);
    });
    setListOfStudentIds(studentIds);
  }, [students]);

  useEffect(() => {
    mutate(period.period.id, {
      onSuccess: (data) => {
        setInformationPersons(data);
      },
      throwOnError: true,
      onError: (data) => {
        toast.warn(data.response.data);
      },
    });
  }, [period, mutate]);

  const selectSupervisorDocument = (sl) => {
    switch (sl) {
      case "supervisor":
        return (
          <div>
            {period.period.students.map((stud) => {
              return (
                <Fragment key={uuid()}>
                  <Row key={uuid()} style={{ margin: ".2rem" }}>
                    <Col lg="5" style={{ marginLeft: ".8rem" }}>
                      <FormattedMessage id="Student" />: {stud.student.name}
                    </Col>
                  </Row>
                  {stud.supervisors.map((sv) => {
                    return (
                      <Row
                        key={uuid()}
                        style={{
                          margin: ".2rem",
                          paddingTop: "0",
                          paddingLeft: ".8rem",
                        }}
                      >
                        <Col>
                          <LabelAsRow
                            style={{
                              marginRight: "0",
                              marginBottom: "0",
                              marginLeft: "0",
                              borderRadius: "5px",
                            }}
                            onClick={() => {
                              setSupervisor(sv.supervisor);
                              toggleSupervisorInfo();
                            }}
                          >
                            <Label
                              style={{
                                margin: "0",
                                background: "transparent",
                                cursor: "pointer",
                              }}
                            >
                              <FormattedMessage id="Supervisor" />:{" "}
                              {sv.supervisor.name}
                            </Label>
                          </LabelAsRow>
                        </Col>
                        <Col>
                          <ButtonSendActivationMail
                            user={{
                              email: sv.supervisor.email,
                              activatedAccount: sv.supervisor.activatedAccount,
                            }}
                            leftAlign={false}
                            printButtonText={true}
                          />
                        </Col>
                      </Row>
                    );
                  })}
                </Fragment>
              );
            })}
            <CardFooter
              className="mt-auto py-0"
              style={{
                position: "absolute",
                bottom: "0",
                width: "100%",
                left: "0",
              }}
            >
              <div className="justify-content-end d-flex">
                <Button
                  outline
                  color="primary"
                  className="m-2"
                  onClick={() => {
                    toggleSupervisorModifyer();
                  }}
                >
                  <FormattedMessage id="EditSupervisorsAndStudents" />
                </Button>
              </div>
            </CardFooter>
            <ModifySupervisorsModal
              allSupervisors={allSupervisors}
              isOpen={modifySupervisorsOpen}
              toggle={toggleSupervisorModifyer}
              allStudents={allStudents}
              period={period}
              listOfStudentIds={listOfStudentIds}
              schoolId={schoolId}
              level={level}
              objId={objId}
              programTeachers={programTeachers}
              programId={programId}
              teacherInfo={teacherInfo}
            />
          </div>
        );
      case "documents":
        const documentsForLevelUsers = period.documents.filter((doc) => {
          const hasStudentAccess = doc.documentAccesses.some(
            (user) =>
              user.userType === "Student" &&
              students.some((stud) => stud.id === user.id)
          );

          const hasAplSupervisorWithCorrectAccess =
            doc.documentAccesses.every(
              (user) => user.userType === "AplSupervisor"
            ) ||
            doc.documentAccesses.some(
              (user) =>
                user.userType === "AplSupervisor" &&
                students.some((stud) => stud.id === user.id)
            );
          return hasStudentAccess || hasAplSupervisorWithCorrectAccess;
        });
        return (
          <>
            <div style={{ position: "relative", width: "100%" }}>
              {period &&
                documentsForLevelUsers.map((value, index) => {
                  var docName =
                    value.description?.length > 0
                      ? value.description
                      : value.documentPath.split("\\")[2].split(".")[0];
                  return (
                    <Row
                      key={uuid()}
                      style={{
                        margin: ".2rem",
                        paddingLeft: "1rem",
                        paddingRight: "1rem",
                        paddingBottom: "0",
                        paddingTop: ".3rem",
                      }}
                    >
                      <Col className="flex-grow-0">
                        <Button
                          color="danger"
                          outline
                          size="sm"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            deleteDocument.mutate(value.id, {
                              onSuccess: () => {
                                var tempPeriod = period;
                                tempPeriod.documents.splice(index, 1);
                                setPeriod(tempPeriod);
                              },
                              throwOnError: true,
                              onError: (data) => {
                                toast.warn(data.response.data);
                              },
                            });
                          }}
                        >
                          <FontAwesomeIcon icon="trash" />
                        </Button>
                      </Col>
                      <Col>
                        <LabelAsRow
                          style={{
                            marginTop: "0",
                            marginRight: "0",
                            marginBottom: "0",
                            marginLeft: "-1rem",
                            borderRadius: "5px",
                          }}
                          onClick={() =>
                            window.open(
                              BASE_LOGIN_REDIRECT_URL_NO_LWC +
                                "/" +
                                value.documentPath,
                              "_blank"
                            )
                          }
                        >
                          {" "}
                          <Col
                            style={{
                              background: "transparent",
                              paddingLeft: "0",
                            }}
                          >
                            <Label
                              style={{
                                margin: "0",
                                background: "transparent",
                                cursor: "pointer",
                              }}
                            >
                              {docName}
                            </Label>

                            {value.documentAccesses.some(
                              (acc) => acc.userType === "Student"
                            ) && (
                              <>
                                <span className="small ps-3 pe-1">
                                  <FormattedMessage id="Students" />:
                                </span>
                                {value.documentAccesses
                                  .filter((acc) => acc.userType === "Student")
                                  .map((access, i) => {
                                    return (
                                      <span className="small" key={access.id}>
                                        {access.name}
                                        {value.documentAccesses.filter(
                                          (acc) => acc.userType === "Student"
                                        ).length -
                                          1 ===
                                        i
                                          ? ". "
                                          : ", "}
                                      </span>
                                    );
                                  })}
                              </>
                            )}
                            {value.documentAccesses.some(
                              (acc) => acc.userType === "AplSupervisor"
                            ) && (
                              <>
                                <span className="small ps-3 pe-1">
                                  <FormattedMessage id="Supervisors" />:
                                </span>
                                {value.documentAccesses
                                  .filter(
                                    (acc) => acc.userType === "AplSupervisor"
                                  )
                                  .map((access, i) => {
                                    return (
                                      <span className="small" key={access.id}>
                                        {access.name}
                                        {value.documentAccesses.filter(
                                          (acc) =>
                                            acc.userType === "AplSupervisor"
                                        ).length -
                                          1 ===
                                        i
                                          ? ". "
                                          : ", "}
                                      </span>
                                    );
                                  })}
                              </>
                            )}
                          </Col>
                        </LabelAsRow>
                      </Col>
                    </Row>
                  );
                })}
            </div>
            <CardFooter
              className="mt-auto py-0"
              style={{
                position: "absolute",
                bottom: "0",
                width: "100%",
                left: "0",
              }}
            >
              <div className="justify-content-end d-flex">
                <Button
                  outline
                  color="primary"
                  className="m-2"
                  onClick={toggle}
                >
                  <FormattedMessage id="AddDocuments" />
                </Button>
              </div>
            </CardFooter>
          </>
        );
      case "importantPersons":
        return (
          <>
            {" "}
            <Col>
              {informationPersons &&
                informationPersons
                  .filter(
                    (infoPerson) =>
                      infoPerson.forUserIds.length > 0 &&
                      (level === "Student" && infoPerson.forUserIds
                        ? infoPerson.forUserIds.includes(objId)
                        : true)
                  )
                  .map((infoPerson, i) => {
                    return (
                      <Fragment key={uuid()}>
                        <LabelAsRow
                          style={{
                            margin: ".2rem",
                            padding: "1rem",
                            paddingBottom: "0",
                            paddingTop: ".3rem",
                            paddingLeft: ".3rem",
                          }}
                          onClick={() => {
                            setAplInfoPerson(infoPerson);
                            toggleInfoPersonOpen();
                          }}
                        >
                          <Col
                            style={{
                              background: "transparent",
                              paddingLeft: "0",
                            }}
                          >
                            <Label
                              style={{
                                margin: "0",
                                background: "transparent",
                                cursor: "pointer",
                              }}
                            >
                              {infoPerson.name}
                            </Label>
                          </Col>
                        </LabelAsRow>
                        <br />
                      </Fragment>
                    );
                  })}
            </Col>
            <CardFooter
              className="mt-auto py-0"
              style={{
                position: "absolute",
                bottom: "0",
                width: "100%",
                left: "0",
              }}
            >
              <div className="justify-content-end d-flex">
                <Button
                  outline
                  color="primary"
                  className="m-2"
                  onClick={() => {
                    toggleInformationPerson();
                  }}
                >
                  <FormattedMessage id="EditInformationPersonsAndConnection" />
                </Button>
              </div>
            </CardFooter>
          </>
        );
      default:
        return;
    }
  };

  const toFormData = (file, paramName) => {
    if (!file) return null;

    var myData = new FormData();
    myData.append(paramName, file);
    return myData;
  };

  const uploadAdditionalDocuments = async () => {
    const participantIds = [];
    period.period.students.forEach((student) => {
      participantIds.push(student.id);
      student.supervisors.forEach((supervisor) => {
        participantIds.push(supervisor.id);
      });
    });

    for (const doc of aplDocumentsWithUsers) {
      var userIds = [];
      for (let index = 0; index < doc.users.length; index++) {
        userIds.push(
          doc.users[index].value.student
            ? doc.users[index].value.student.id
            : doc.users[index].value.id
        );
      }
      if (!doc.users.length) {
        toast.warn(
          "Dokumentet " +
            doc.description +
            " är inte kopplat till någon och kan därför inte laddas upp"
        );
      } else {
        const docdata = await axios
          .post(
            `/Apl/PostDocumentForPeriod?description=${
              doc.description
            }&periodId=${period.period.id}&userIds=${userIds.join(
              "&userIds="
            )}`,
            toFormData(doc.document, "document"),
            { headers: { "Content-Type": "multipart/form-data;" } }
          )
          .catch((err) => {
            toast.warn(err.response.data);
          });
        if (docdata && docdata.status > 199 && docdata.status < 300) {
          toast.success("Dokument sparade");
          period.documents.push(docdata.data.result);
        }
      }
    }
    setAplDocumentsWithUsers([]);
  };

  const saveInformationPersonsAndUsersForPeriod = (newInfoPersonsWithUsers) => {
    let saveObject = { periodId: period.period.id, users: [] };
    newInfoPersonsWithUsers.forEach((infopers) => {
      let infoPerson = { id: infopers.id, userIds: [] };
      infopers.forUsers.forEach((user) => {
        infoPerson.userIds.push(user.id);
      });
      saveObject.users.push(infoPerson);
    });

    postAplInfoPersonsAndUsers.mutate(saveObject, {
      onSuccess: (data) => {
        mutate(period.period.id, {
          onSuccess: (data) => {
            setInformationPersons(data);
            toast.success("Kontaktpersoner uppdaterade");
            setInformationPersonIsOpen(false);
          },
          throwOnError: true,
          onError: (data) => {
            toast.warn(data.response.data);
          },
        });
      },
    });
  };

  const saveInformationPerson = (person) => {
    postAplInfoPerson.mutate(
      {
        aplPeriodId: period.period.id,
        name: person.name,
        mail: person.mail,
        phoneNumber: person.phoneNumber,
        forUserIds: [],
      },
      {
        onSuccess: (data) => {
          mutate(period.period.id, {
            onSuccess: (data) => {
              setInformationPersons(data);
            },
            throwOnError: true,
            onError: (data) => {
              toast.warn(data.response.data);
            },
          });
        },
        throwOnError: true,
        onError: (data) => {
          toast.warn(data.response.data);
        },
      }
    );
  };

  const handleChange = (event, newValue) => {
    setLevelSupervisor(newValue);
  };

  return (
    <Col lg={12}>
      <Card style={{ height: "35vh", marginBottom: "1rem" }}>
        <ScrollContainer vertical={false}>
          <Box>
            <Tabs
              value={levelSupervisor}
              onChange={handleChange}
              indicatorColor="white"
            >
              <Tab
                className={
                  levelSupervisor === "supervisor"
                    ? "apl-administer-tabs--Selected"
                    : "apl-administer-tabs--UnSelected"
                }
                label={<FormattedMessage id="SupervisorsAndStudents" />}
                value="supervisor"
                wrapped
              />
              <Tab
                className={
                  levelSupervisor === "importantPersons"
                    ? "apl-administer-tabs--Selected"
                    : "apl-administer-tabs--UnSelected"
                }
                label={<FormattedMessage id="ContactPersons" />}
                value="importantPersons"
                wrapped
              />
              <Tab
                className={
                  levelSupervisor === "documents"
                    ? "apl-administer-tabs--Selected"
                    : "apl-administer-tabs--UnSelected"
                }
                label={<FormattedMessage id="Documents" />}
                value="documents"
                wrapped
              />
            </Tabs>
          </Box>
        </ScrollContainer>
        <div style={{ height: "calc(100% - 6.2rem)", overflowY: "auto" }}>
          {selectSupervisorDocument(levelSupervisor)}
        </div>
        {period && (
          <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader>
              {" "}
              <FormattedMessage id="Documents" />
            </ModalHeader>
            <Card style={{ marginBottom: "0", height: "34rem" }}>
              <CardBody style={{ overflowY: "auto" }}>
                <CardTitle>
                  {" "}
                  <p className="lead">
                    <FormattedMessage id="Documents" />
                  </p>
                </CardTitle>
                <ModalBody style={{ border: "none", padding: "0" }}>
                  <CreateAPLPeriodDocuments
                    aplDocumentsWithUsers={aplDocumentsWithUsers}
                    setAplDocumentsWithUsers={setAplDocumentsWithUsers}
                    aplStudentSupervisors={period.period.students}
                    students={period.period.students}
                    supervisors={supervisorsInPeriod}
                    isModifying={true}
                  />
                </ModalBody>
              </CardBody>
              <CardFooter>
                <div className="justify-content-end d-flex">
                  <Button
                    outline
                    className="m-2"
                    color="secondary"
                    onClick={toggle}
                  >
                    <FormattedMessage id="Cancel" />
                  </Button>
                  <Button
                    color="primary"
                    outline
                    className="m-2"
                    onClick={() => {
                      uploadAdditionalDocuments();
                      toggle();
                    }}
                  >
                    <FormattedMessage id="Upload" />
                  </Button>
                </div>
              </CardFooter>
            </Card>
          </Modal>
        )}
        {period && supervisorsInPeriod && (
          <ModifyAPLInformationPersonModal
            periodId={period.period.id}
            students={period.period.students}
            supervisors={supervisorsInPeriod}
            setInformationPersons={setInformationPersons}
            informationPersons={informationPersons}
            infoPersonUsers={infoPersonUsers}
            setInfoPersonUsers={setInfoPersonUsers}
            updateInfoPersonAddUsers={updateInfoPersonAddUsers}
            updateInfoPersonRemoveUsers={updateInfoPersonRemoveUsers}
            informationPersonIsOpen={informationPersonIsOpen}
            toggleInformationPerson={toggleInformationPerson}
            saveInformationPerson={saveInformationPerson}
            saveInformationPersonsAndUsersForPeriod={
              saveInformationPersonsAndUsersForPeriod
            }
            level={level}
            objId={objId}
            programId={programId}
          />
        )}
      </Card>
    </Col>
  );
}

const Label = styled.label`
  margin: auto 1rem;
  background: white;
`;

const LabelAsRow = styled(Label)`
  margin: auto 0;
  padding: 0.1rem 0.5rem;
  cursor: pointer;
  background: white;
  &:hover {
    background: #20a8d8;
    color: white;
    cursor: pointer;
    transition: all 0.2s linear;
    border-radius: 1rem;
  }
`;
